module.exports = __webpack_public_path__ + "img_logo_bizny@1x.png?e38fd0b7f46ea2347004636d0b1aff38";